<template>
    <div>
        <div class="content-box mr60">
            <p style="text-align: center;">当前素材为“已拒绝”是否继续通过</p>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 通过素材弹框-->
<script>

import API from "@/api/workOrder/material.js"
export default {
    name: "resultModal",
    props:['cbs', 'id'],
    data(){
        return {
            formLoading:false,
            formItem:{
                group:'',
            },
            rules:{

            },
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            this.fetchBatchPass()
        },
        hideModal(){
            this.$emit('close');
        },
        //批量选中
        fetchBatchPass(id) {
            this.formLoading = true
            API.postWorkOrderPass({material_id:this.id}).then(res=>{
                this.$message.success(res.info)
                this.cbs.onSubmit()
                this.formLoading = false
            },err=>{
                this.$message.error(err.info)
            }).finally(()=>{
                this.formLoading = false
            })
        },
    }
}
</script>

<style scoped>

</style>
